import { newToolFilterOAuthMcp } from "../oauth.ts";
import type { McpServerSpecResolver } from "../types.ts";

/** Tells the agent what a LaunchDarkly permission error means and how the
 *  user gets the role it needs. The catalog entry reaches tenants without the
 *  LaunchDarkly integration, so the `p0 request` step is conditional.
 */
const launchDarklyPermissionHint = `LaunchDarkly checks the user's own LaunchDarkly role on every call. If a LaunchDarkly tool fails with a permission error (403, "forbidden" or "insufficient permissions"), the user's role doesn't allow it, and requesting tool access again won't help. If the organization manages LaunchDarkly access in P0, ask the user to request the base role the call needs, for example \`p0 request launchdarkly base-role <account>/writer\`, then retry the call. While a custom role is assigned, it replaces the user's base role, so a user with a custom role has to ask their LaunchDarkly admin to remove it first. If the organization doesn't manage LaunchDarkly access in P0, ask the user to get a LaunchDarkly role that allows the call from their LaunchDarkly admin. The user doesn't need to reconnect the server.`;

const baseResolver = newToolFilterOAuthMcp({
  iconUrl: "https://launchdarkly.com/favicon.ico",
  label: "LaunchDarkly",
  url: "https://mcp.launchdarkly.com/mcp/launchdarkly",
});

export const launchDarklyMcpResolver: McpServerSpecResolver = (location) => {
  const spec = baseResolver(location);
  return {
    ...spec,
    access: {
      ...spec.access,
      prompt: `${spec.access.prompt}\n${launchDarklyPermissionHint}`,
      propagationHint: launchDarklyPermissionHint,
    },
  };
};
